import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'statusTag'
})

export class StatusTagPipe implements PipeTransform {
    transform(status: string): { severity: "success" | "info" | "warning" | "danger" | "secondary" | "contrast"; value: string; styles: { background: string; color: string, width: string, textAlign: string } } {
        switch (status?.toLowerCase()) {
            case 'open':
                return { severity: 'info', value: 'Open', styles: { background: '#E0F2FE', color: '#0284C7', width: '70px', textAlign: 'center' } };
            case 'new':
                return { severity: 'info', value: 'New', styles: { background: '#E0F2FE', color: '#0284C7', width: '70px', textAlign: 'center' } }; 
            case 'pending':
                return { severity: 'warning', value: 'Pending', styles: { background: '#FEF3C7', color: '#B45309', width: '70px', textAlign: 'center' } }; 
            case 'resolved':
                return { severity: 'success', value: 'Resolved', styles: { background: '#D1FAE5', color: '#065F46', width: '70px', textAlign: 'center' } };
            case 'failed':
                return { severity: 'danger', value: 'Failed', styles: { background: '#FCD8D8', color: '#9B2C2C', width: '70px', textAlign: 'center' } };
            case 'paid':
                return { severity: 'success', value: 'Paid', styles: { background: '#9AE3A2', color: '#2F855A', width: '70px', textAlign: 'center' } };
            case 'cancelled':
                return { severity: 'warning', value: 'Cancelled', styles: { background: '#FCD38B', color: '#9C5F24', width: '70px', textAlign: 'center' } };
            case 'requested':
                return { severity: 'info', value: 'Requested', styles: { background: '#B9D6F9', color: '#2C5282', width: '70px', textAlign: 'center' } };
            case 'generated':
                return { severity: 'info', value: 'Generated', styles: { background: '#D6A9F4', color: '#5A3F9E', width: '70px', textAlign: 'center' } };
            default:
                return { severity: 'secondary', value: 'Unknown', styles: { background: '#E5E5E5', color: '#9E9E9E', width: '70px', textAlign: 'center' } };

        }
    }
}
